import { useCallback, useState } from 'react';

export const SUBMENU_WIDTH = 150;
const SUBMENU_GAP = 6;

export type SubmenuSide = 'left' | 'right';

export default function useSubmenuSide() {
  const [side, setSide] = useState<SubmenuSide>('right');

  const resolveSide = useCallback((anchor: HTMLElement | null) => {
    const rect = anchor?.getBoundingClientRect();
    if (!rect) return;

    setSide(rect.right + SUBMENU_GAP + SUBMENU_WIDTH > window.innerWidth ? 'left' : 'right');
  }, []);

  const submenuSideClass = side === 'left' ? 'right-[calc(100%+6px)]' : 'left-[calc(100%+6px)]';

  return { side, submenuSideClass, resolveSide };
}
